<div class="header-main content-web-section margin-bottom-30">
  <div class="fixed-header">
      <div id="wrapper " class="logo-bg">
          <div id="parallelogram"></div>
      </div>
      <div class="triangle-up"></div>

      <img src="assets/images/logo_ITI.png" class="logo img-responsive cursor-pointer" (click)="homeNav()" />
      <div class="header-1">
          <div class="col-lg-12 row">
              <div class="col-lg-3"></div>
              <div class="col-lg-9 top-section respons-padding">
                  <div class="col-lg-12 row respons-padding">
                      <div class="col-lg-5 top">
                          <marquee behavior="scroll" direction="left" loop="true" onmouseover="stop()" onmouseout="start()">
                              <span class="top-share-info">
                                <ng-template ngFor let-item [ngForOf]="latestNav">
                                  <span class="text1">NAVs as on &nbsp;{{ item?.date | date: 'dd MMM yyyy'}} </span>
                                  &nbsp;{{item?.scheme}} {{item?.plan}} {{item?.currentNav}} <span *ngIf="item?.percentage ">({{item?.percentage | number : '1.2-2'}}%) &nbsp;</span>
                                  <img src="assets/icons/up_arrow.png" *ngIf="item?.percentage>0" />
                                  <img src="assets/icons/down_arrow.png" *ngIf="item?.percentage<=0" />
                                </ng-template>  
                              </span>
                             
                          </marquee>
                      </div>
                      <div class="col-lg-7 respons-padding">
                          <span class="contact-info web-section">
                              <span class="tab-seperator seperator-1"></span>
                              <img src="assets/icons/Email_icon_white.png" (click)="mailTo('mfassist@itiorg.com')" class="cursor-pointer" /> &nbsp;&nbsp;mfassist@itiorg.com &nbsp;&nbsp; <span class="tab-seperator"></span>&nbsp;&nbsp;
                              <img src="assets/icons/Path.png" (click)="phoneTo(18002669603)" class="cursor-pointer" />&nbsp;&nbsp;1800-266-9603
                          </span>

                          <span class="contact-info mobile-section mobile-contact">
                              <i class="fa fa-envelope mobile-icon" aria-hidden="true"></i> &nbsp; <i class="fa fa-phone mobile-icon" aria-hidden="true"></i>&nbsp;
                              <i class="fa fa-map-marker mobile-icon" aria-hidden="true"></i>
                          </span>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="header-2 col-lg-12 row padding-right-0">
          <div class="col-lg-3"></div>
          <div class="col-lg-9  padding-left-0 padding-right-0 header-top-menu">
              <span class="top-menus header-top-left-menu">
                  <span class="header-top-left-menu--name cursor-pointer" *ngFor="let item of headerData.topMenus" (click)="navPage(item.url,item.val)" [ngClass]="{'active-tab':activeTab===item.val}">
                      {{item.displayName}}</span>
              </span>
              <span class="top-menus2 header-top-right-menu">
                  <button type="button" id="invest" (click)="investOnline()" class="invest cursor-pointer mr-3 web-section">Invest Online</button>
                  <img src="assets/icons/menu_white.png" class="cursor-pointer" (click)="openNav()" />
              </span>
          </div>
      </div>
  </div>
  <div class="header-3">
      <div class="top-cion hidden-xs">
          <ul class="services_wrpdiv1">
              <li class="li1">
                  <a (click)="openPopUp('callback')"> <img src="assets/icons/Group 4.png" class="img-set" alt="Call" />&nbsp;&nbsp;REQUEST A CALLBACK</a>
              </li>
          </ul>
          <ul class="services_wrpdiv2">
              <li class="li2">
                  <a (click)="openPopUp('write')"> <img src="assets/icons/noun_write_628018.png" class="img-set" alt="Mail" />&nbsp;&nbsp;WRITE TO US</a>
              </li>
          </ul>
          <ul class="services_wrpdiv3">
              <li class="li3">
                  <a (click)="openPopUp('locate')"> <img src="assets/icons/locate_us_icon_grey.png" class="img-set" alt="Map" /> &nbsp;&nbsp;LOCATE US</a>
              </li>
          </ul>
      </div>

      <div id="myCarousel" data-interval="3000" class="carousel slide" data-ride="carousel" *ngIf="data.hasCarousel">
          <ol class="carousel-indicators">
              <li *ngFor="let item of banners;let i=index;" 
                data-target="#myCarousel" class="{{ (i == 0) ? 'active' : '' }}" 
                attr.data-slide-to="{{i}}" >
              </li>
          </ol>
          <div class="carousel-inner">
            <ng-template ngFor let-item [ngForOf]="banners" let-i="index">
              <div *ngIf="item.filePath" class="carousel-item"  [ngClass]="{'active':i===0}">
                  <img [src]="item.filePath" [alt]="item.schemeName" style="width: 100%;" class="img-responsive bnr-img-home img-bread-crumb cursor-pointer" (click)="viewDetails(item)" />
              </div>
              </ng-template>
          </div>
      </div>
      <div class="bread-crumb" *ngIf="(data | json) != '{}' && !data.hasCarousel">
          <img [src]="data.headerImgPath" alt="Bread crumb" style="width: 100%;" class="img-responsive img-bread-crumb" />
      </div>
      <div class="img-over-text" [ngClass]="{'custom-crumb':subBreadCrumb?.position==='small'}" *ngIf="(data | json) != '{}' && !data.skipBreadCrumb">
          <span class="bread-crumb-data">
              <span class="cursor-pointer" (click)="navFromBreadCrumb('/')"> Home </span>
              <span class="bread-crumb-seperator"> > </span>
          </span>
          <span class="bread-crumb-data">
              <span class="cursor-pointer" [ngClass]="{'bread-crumb-data-active':!subBreadCrumb}" (click)="navFromBreadCrumb(data.url)"> {{data.breadCrumb}}</span>
              <span class="bread-crumb-seperator bread-crumb-data-active" *ngIf="subBreadCrumb?.val"> > {{subBreadCrumb?.val}} </span>
          </span>
          <div class="page-heading">
           <span *ngIf="(subBreadCrumb?.heading && !subBreadCrumb.makeSubBreadCrumbValAsHeader )|| !subBreadCrumb">{{ data.breadCrumb }}</span>
           <span *ngIf="(subBreadCrumb?.heading && subBreadCrumb.makeSubBreadCrumbValAsHeader)">{{ subBreadCrumb?.val }}</span>
          </div>
      </div>
  </div>
</div>
<!---MOBILE-->
<div class="header-main header-main-mobile content-mobile-section">
  <div class="fixed-header">
      <div id="wrapper " class="logo-bg">
          <div id="parallelogram"></div>
      </div>
      <div class="triangle-up"></div>

      <img src="assets/images/logo_ITI.png" class="logo img-responsive cursor-pointer" (click)="homeNav()" width="100" />
      <div class="header-1">
          <div class="col-lg-12 row">
              <div class="col-lg-3"></div>
              <div class="col-lg-9 top-section respons-padding">
                  <div class="col-lg-12 row respons-padding">
                      <div class="col-lg-5 dummy-placeholder">
                      </div>
                      <div class="col-lg-7 respons-padding">
                          <span class="contact-info web-section">
                              <span class="tab-seperator seperator-1"></span>
                              <img src="assets/icons/Email_icon_white.png" (click)="mailTo('mfassist@itiorg.com')" class="cursor-pointer" /> &nbsp;&nbsp;mfassist@itiorg.com &nbsp;&nbsp; <span class="tab-seperator"></span>&nbsp;&nbsp;
                              <img src="assets/icons/Path.png" (click)="phoneTo(18002669603)" class="cursor-pointer" />&nbsp;&nbsp;1800-266-9603
                          </span>

                          <span class="contact-info mobile-section mobile-contact">
                              <img  alt="Mail" src="assets/icons/noun_write_628018.png" (click)="openPopUpMobile('write-to-us')" class="cursor-pointer" />&nbsp;&nbsp;&nbsp;
                              <img (click)="openPopUpMobile('call-back')" src="assets/icons/Group 4.png" alt="call" class="cursor-pointer" />&nbsp;&nbsp;&nbsp;
                              <img  alt="Map" src="assets/icons/locate_us_icon_grey.png" (click)="openPopUpMobile('locate-us')" class="cursor-pointer" />
                           </span>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="header-2 col-lg-12 row">
          <div class="col-lg-3"></div>
          <div class="col-lg-9 pt-3 respons-padding">
              <span class="top-menus">
                  <span class="cursor-pointer" *ngFor="let item of headerData.topMenus" (click)="navPage(item.url,item.val)" [ngClass]="{'active-tab':activeTab===item.val}">
                      {{item.displayName}} &nbsp;&nbsp;
                  </span>
              </span>
              <span class="top-menus2 respons-padding">
                  
                  <button type="button" id="invest" (click)="investOnline()" class="invest cursor-pointer mr-3 web-section">Invest Online</button>

                <div class="align-h">
                    <marquee behavior="scroll" direction="left" loop="true" onmouseover="stop()" onmouseout="start()">
                        <span class="">
                            <ng-template ngFor let-item [ngForOf]="latestNav">
                            <span class="text1">NAVs as on &nbsp;{{ item?.date | date: 'dd MMM yyyy'}} </span>
                            &nbsp;{{item?.scheme}} {{item?.plan}} {{item?.currentNav}} ({{item?.percentage | number : '1.2-2'}}%) &nbsp;
                            <img src="assets/icons/up_arrow.png" *ngIf="item?.percentage>0" />
                            <img src="assets/icons/down_arrow.png" *ngIf="item?.percentage<=0" />
                        </ng-template>
                        </span>
                    </marquee>
                    <img src="assets/icons/menu_white.png" class="cursor-pointer nav-img" (click)="openNav()" />
                </div>
              </span>
          </div>
      </div>
  </div>
  <div class="header-3">
      <div class="top-cion hidden-xs">
          <ul class="services_wrpdiv1">
              <li class="li1">
                  <a (click)="openPopUp('callback')"> <img src="assets/icons/phone_icon_grey.png" class="img-set" alt="Call" />&nbsp;&nbsp;REQUEST A CALLBACK</a>
              </li>
          </ul>
          <ul class="services_wrpdiv2">
              <li class="li2">
                  <a (click)="openPopUp('write')"> <img src="assets/icons//write_to_us_icon_grey.png" class="img-set" alt="Mail" />&nbsp;&nbsp;WRITE TO US</a>
              </li>
          </ul>
          <ul class="services_wrpdiv3">
              <li class="li3">
                  <a (click)="openPopUp('locate')"> <img src="assets/icons/locate_us_icon_grey.png" class="img-set" alt="Map" /> &nbsp;&nbsp;LOCATE US</a>
              </li>
          </ul>
      </div>

      <div id="myCarousel" data-interval="3000" class="carousel slide" data-ride="carousel" *ngIf="data.hasCarousel ">
          <ol class="carousel-indicators">
              <li *ngFor="let item of banners;let i=index;" data-target="#myCarousel" class="{{ (i == 0) ? 'active' : '' }}" attr.data-slide-to="{{i}}"></li>
          </ol>
          <div class="carousel-inner">
            <ng-template ngFor let-item [ngForOf]="banners" let-i="index">
              <div *ngIf="item.filePath" class="carousel-item"  [ngClass]="{'active':i===0}">
                  <img [src]="item.filePath" alt="Header Slide images" style="width: 100%;" class="img-responsive bnr-img-home img-bread-crumb cursor-pointer" (click)="viewDetails(item)" />
              </div>
            </ng-template>
          </div>
      </div>
      <div class="bread-crumb" *ngIf="(data | json) != '{}' && !data.hasCarousel">
          <img [src]="data.headerImgPath" alt="Bread crumb" style="width: 100%;" class="img-responsive img-bread-crumb" />
      </div>
      <div class="img-over-text" [ngClass]="{'custom-crumb':subBreadCrumb?.position==='small'}" *ngIf="(data | json) != '{}' && !data.skipBreadCrumb">
          <span class="bread-crumb-data">
              <span class="cursor-pointer" (click)="navFromBreadCrumb('/')"> Home </span>
              <span class="bread-crumb-seperator"> > </span>
          </span>
          <span class="bread-crumb-data">
              <span class="cursor-pointer" [ngClass]="{'bread-crumb-data-active':!subBreadCrumb}" (click)="navFromBreadCrumb(data.url)"> {{data.breadCrumb}}</span>
              <span class="bread-crumb-seperator bread-crumb-data-active" *ngIf="subBreadCrumb?.val"> > {{subBreadCrumb?.val}} </span>
          </span>
          <div class="page-heading" *ngIf="subBreadCrumb?.heading || !subBreadCrumb ">
           {{ data.breadCrumb }}
          </div>
      </div>
  </div>
</div>

<!---SOCIAL SHARE-->
<ul *ngIf="isSocialShare" class="social-share-navigation">
  <li class="social-share-navigation-item linkedin">
      <div class="social-share-navigation-item-icon">
          <a href="https://in.linkedin.com/company/iti-mutual-fund" class="fa fa-linkedin" target="_blank"> </a>
      </div>
      <div class="social-share-navigation-item-text">
          LinkedIn
      </div>
  </li>
  <li class="social-share-navigation-item twitter">
      <div class="social-share-navigation-item-icon">
          <a href="https://twitter.com/itimutualfund?lang=en" class="fa fa-twitter" target="_blank"> </a>
      </div>
      <div class="social-share-navigation-item-text">
          Twitter
      </div>
  </li>
  <li class="social-share-navigation-item facebook">
      <div class="social-share-navigation-item-icon">
          <a href="https://m.facebook.com/ITIMutualFund/" class="fa fa-facebook" target="_blank"> </a>
      </div>
      <div class="social-share-navigation-item-text">
          Facebook
      </div>
  </li>
  <li class="social-share-navigation-item google">
      <div class="social-share-navigation-item-icon"> 
          <a href="https://www.youtube.com/channel/UCpWl987-i9dvbfiTOLQIleQ" class="fa fa-youtube gplus" target="_blank"> </a>
      </div>
      <div class="social-share-navigation-item-text">
          Youtube
      </div>
  </li>
</ul>
